import React, { useContext, useEffect, createContext } from 'react';

// project-imports
import { showToast } from '../components/sweet-alert/Sweetalert';
import { fetchData, getGallery } from './salesforce_api_context';
import { GET_GALLERY_DATA_BEGIN, GET_GALLERY_DATA_SUCCESS, GET_GALLERY_DATA_FAILURE, GET_POPULAR_VIDEO_BEGIN, GET_POPULAR_VIDEO_SUCCESS, GET_POPULAR_VIDEO_FAILURE, GET_POPULAR_SHORTS_BEGIN, GET_POPULAR_SHORTS_SUCCESS, GET_POPULAR_SHORTS_FAILURE, GET_POPULAR_LIVE_VIDEO_BEGIN, GET_POPULAR_LIVE_VIDEO_SUCCESS, GET_POPULAR_LIVE_VIDEO_FAILURE, GET_LAST_TWO_WEEK_TRENDING_VIDEOS_BEGIN, GET_LAST_TWO_WEEK_TRENDING_VIDEOS_SUCCESS, GET_LAST_TWO_WEEK_TRENDING_VIDEOS_FAILURE, GET_LATEST_VIDEO_BEGIN, GET_LATEST_VIDEO_SUCCESS, GET_LATEST_VIDEO_FAILURE } from '../constants/actions';
// import instructorData1 from '../data/instructor/InstructorData.json';
// import ourGalleryData from "../data/youtube/new-updated-youtube-data.json"
import ourGalleryData from "../data/ourGallery/GalleryData.json";
import { useBugContext } from './bug_context';

// third-party
import { useDispatch, useSelector } from "react-redux";

// Reading environment variable start
const ytplatformName = process.env.REACT_APP_PLATFORM_NAME;
const language = process.env.REACT_APP_LANGUAGE;
// Reading environment variable end

// Create context
export const GalleryContext = createContext();

export const GalleryProvider = (props) => {

    // Reading dispatch from Store
    const dispatch = useDispatch();

    const { bugReportApi } = useBugContext();

    // Constant variable
    const galleryData = useSelector(state => state.gallery);

    // Constant function

    // Function to get the Gallery data
    const fetchGalleryData = async () => {
        try {

            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_GALLERY_DATA_BEGIN, payload: true });


            // Calling API to get data
            // let response = await getGallery();
            let response = await fetchData(`/api/video-content?platformName=${ytplatformName}&language=${language}`);

            // let response = ourGalleryData;

            // Dispatching the actions on success
            dispatch({ type: GET_GALLERY_DATA_SUCCESS, payload: response });

            // Showing the toast message on getting instructor data successfully
            // showToast("success", "Getting instructor details successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("55 : gallery_context : Error while getting gallery data::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: GET_GALLERY_DATA_FAILURE, payload: error && error.message });

            bugReportApi("Error while fetching gallery all video content data", `/api/video-content?platformName=${ytplatformName}&language=${language}`, "GET", error);

            // Showing the toast message on getting instructor unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to get the gallery data!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    }

    const fetchPopularVideos = async () => {
        try {

            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_POPULAR_VIDEO_BEGIN, payload: true });


            // Calling API to get data
            // let response = await getGallery();
            let response = await fetchData(`/api/popular-videos/${ytplatformName}`);

            // let response = ourGalleryData;

            // Dispatching the actions on success
            dispatch({ type: GET_POPULAR_VIDEO_SUCCESS, payload: response });

            // Showing the toast message on getting instructor data successfully
            // showToast("success", "Getting instructor details successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("86 : gallery_context : Error while getting popular videos::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: GET_POPULAR_VIDEO_FAILURE, payload: error && error.message });

            bugReportApi("Error while fetching popular videos", `/api/popular-videos/${ytplatformName}`, "GET", error);

            // Showing the toast message on getting instructor unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to get the popular videos data!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    }

    const fetchPopularShorts = async () => {
        try {

            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_POPULAR_SHORTS_BEGIN, payload: true });


            // Calling API to get data
            // let response = await getGallery();
            let response = await fetchData(`/api/popular-shorts/${ytplatformName}`);

            // let response = ourGalleryData;

            // Dispatching the actions on success
            dispatch({ type: GET_POPULAR_SHORTS_SUCCESS, payload: response });

            // Showing the toast message on getting instructor data successfully
            // showToast("success", "Getting instructor details successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("117 : gallery_context : Error while getting popular shorts::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: GET_POPULAR_SHORTS_FAILURE, payload: error && error.message });

            bugReportApi("Error while fetching popular shorts videos", `/api/popular-shorts/${ytplatformName}`, "GET", error);

            // Showing the toast message on getting instructor unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to get the popular shorts data!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    }

    const fetchPopularLiveVideos = async () => {
        try {

            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_POPULAR_LIVE_VIDEO_BEGIN, payload: true });


            // Calling API to get data
            // let response = await getGallery();
            let response = await fetchData(`/api/popular-live-streams/${ytplatformName}`);

            // let response = ourGalleryData;

            // Dispatching the actions on success
            dispatch({ type: GET_POPULAR_LIVE_VIDEO_SUCCESS, payload: response });

            // Showing the toast message on getting instructor data successfully
            // showToast("success", "Getting instructor details successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("148 : gallery_context : Error while getting popular live vidos::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: GET_POPULAR_LIVE_VIDEO_FAILURE, payload: error && error.message });

            bugReportApi("Error while fetching popular live videos", `/api/popular-live-streams/${ytplatformName}`, "GET", error);

            // Showing the toast message on getting instructor unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to get the popular live videos data!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    }

    const fetchLastWeekTrendingVideos = async () => {
        try {

            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_LAST_TWO_WEEK_TRENDING_VIDEOS_BEGIN, payload: true });


            // Calling API to get data
            // let response = await getGallery();
            let response = await fetchData(`/api/last-two-week/video-stats`);

            // let response = ourGalleryData;

            // Dispatching the actions on success
            dispatch({ type: GET_LAST_TWO_WEEK_TRENDING_VIDEOS_SUCCESS, payload: response });

            // Showing the toast message on getting instructor data successfully
            // showToast("success", "Getting instructor details successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("179 : gallery_context : Error while getting last week trending videos::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: GET_LAST_TWO_WEEK_TRENDING_VIDEOS_FAILURE, payload: error && error.message });

            bugReportApi("Error while fetching last-week trending videos", `/api/last-two-week/video-stats`, "GET", error);

            // Showing the toast message on getting instructor unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to get the last week trending videos data!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    }

    const fetchLatestVideos = async () => {
        try {

            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_LATEST_VIDEO_BEGIN, payload: true });


            // Calling API to get data
            // let response = await getGallery();
            let response = await fetchData(`/api/latest-videos/${ytplatformName}`);

            // let response = ourGalleryData;

            // Dispatching the actions on success
            dispatch({ type: GET_LATEST_VIDEO_SUCCESS, payload: response });

            // Showing the toast message on getting instructor data successfully
            // showToast("success", "Getting instructor details successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("210 : gallery_context : Error while getting popular videos::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: GET_LATEST_VIDEO_FAILURE, payload: error && error.message });

            bugReportApi("Error while fetching latest videos", `/api/latest-videos/${ytplatformName}`, "GET", error);

            // Showing the toast message on getting instructor unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to get the popular videos data!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    }
    useEffect(() => {
        fetchGalleryData();
        fetchPopularVideos();
        fetchPopularShorts();
        fetchPopularLiveVideos();
        fetchLastWeekTrendingVideos();
        fetchLatestVideos();
    }, []);

    return (
        <GalleryContext.Provider value={{ ...galleryData, fetchGalleryData }}>
            {props.children}
        </GalleryContext.Provider>
    )
}
export const useGalleryContext = () => {
    return useContext(GalleryContext)
}
